import { AlertBanner, Box } from '@origin-digital/ods-core';
import React from 'react';

export const AlertContainer = (props) => (
  <Box padding="none" paddingBottom="medium">
    <AlertBanner {...props}>{props.children}</AlertBanner>
  </Box>
);
